import React from "react";
import { AuthProvider } from "./auth";
import { ProjectProviderNew } from "./project.context";
import { RsvpProvider } from "./rsvp.context";
import { BudgetProvider } from "./BudgetContext/projectbudgets.context";
import { ServiceProvider } from "./ServicesContext/projectservices.context";
type ProviderProps = {
  children: React.ReactNode;
};
const AppProvider: React.FC<ProviderProps> = ({ children }) => {
  return (
    <AuthProvider>
      <ProjectProviderNew>
        <RsvpProvider>
          <BudgetProvider>
            <ServiceProvider>
              {children}
            </ServiceProvider>
          </BudgetProvider>
        </RsvpProvider>
      </ProjectProviderNew>
    </AuthProvider>
  );
};

export { AppProvider };
